module.exports = __webpack_public_path__ + "img/vcgamers.5e00b2f6.jpg";